// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-3WJRe6Xw","foot_link":"foot_link-n7roX6S0","list":"list-2LX1dxoc","link":"link-3ATseeE0","copyright":"copyright-27LERwj-"};